<template>
  <div>
    <content-panel class="panel-tabs">
      <el-tabs v-model="activeName" class="tabs">
        <el-tab-pane :label="item.label" v-for="item in tables" :key="item.value" :name="item.value">
          <div slot="label">
            <span>{{ item.label }}</span>
            <el-badge :value="item.number" v-if="item.number"></el-badge>
          </div>
        </el-tab-pane>
      </el-tabs>
      <component :is="activeComponent" @getNumber="getNumber"></component>
    </content-panel>
  </div>
</template>

<script>
import PendingListing from './pending-listing/PendingListing';
import CannotBeListed from './cannot-be-listed/CannotBeListed';
import NoListingRequired from './no-listing-required/NoListingRequired';
import AlreadyListed from './already-listed/AlreadyListed';
import pagePathMixin from '@/utils/page-path-mixin';
export default {
  name: 'NewProductArrival',
  mixins: [pagePathMixin],
  components: { PendingListing, CannotBeListed, NoListingRequired, AlreadyListed },
  data() {
    return {
      activeName: 'PendingListing',
      tables: [
        {
          value: 'PendingListing',
          label: '待上架',
          number: '',
        },
        {
          value: 'CannotBeListed',
          label: '暂缓上架',
          number: '',
        },
        {
          value: 'NoListingRequired',
          label: '无需上架',
          number: '',
        },
        {
          value: 'AlreadyListed',
          label: '已上架',
          number: '',
        },
      ],
    };
  },
  computed: {
    activeComponent() {
      return this.activeName;
    },
  },
  mounted() {
    this.$store.dispatch('menu/getMenusNum', {}, {root: true})
    this.getNumber()
  },
  methods: {
    getNumber() {
      this.$q.newProduct.statisticsByState().then((res) => {
        this.tables[0].number = res.data.waiteQty
        this.tables[1].number = res.data.cannotQty
        this.tables[2].number = res.data.noNeedQty
        this.tables[3].number = res.data.finishQty
        
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.panel-tabs
  >>> .main-area
    padding-top 0
.tabs
  >>> .el-tabs__header
    margin-bottom 5px
  >>> .el-badge
        left -4px
  >>> .el-badge__content
        background-color #f56c6c
</style>
